import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { TopNavigation } from '@/components/layout/TopNavigation';
import { Card, CardContent } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useAuth } from '@/contexts/AuthContext';
import { Shield, Building2, Mail, Loader2 } from 'lucide-react';
import { OrganizationsTab } from './OrganizationsTab';
import { SiteInvitesTab } from './SiteInvitesTab';

export function AdminPage() {
  const navigate = useNavigate();
  const { user, isLoading } = useAuth();

  const isSuperadmin = user?.is_superadmin === true;

  // Redirect non-superadmins
  useEffect(() => {
    if (!isLoading && !isSuperadmin) {
      navigate('/');
    }
  }, [isLoading, isSuperadmin, navigate]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background">
        <TopNavigation />
        <div className="container mx-auto py-8 max-w-4xl">
          <Card>
            <CardContent className="flex items-center justify-center py-12">
              <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }

  if (!isSuperadmin) {
    return null; // Will redirect
  }

  return (
    <div className="min-h-screen bg-background">
      <TopNavigation />
      <div className="container mx-auto py-8 max-w-4xl">
        {/* Header */}
        <div className="flex items-center gap-3 mb-6">
          <Shield className="h-6 w-6 text-primary" />
          <h1 className="text-2xl font-bold">Platform Administration</h1>
        </div>

        <Tabs defaultValue="organizations" className="w-full">
          <TabsList className="mb-6">
            <TabsTrigger value="organizations" className="gap-2">
              <Building2 className="h-4 w-4" />
              Organizations
            </TabsTrigger>
            <TabsTrigger value="site-invites" className="gap-2">
              <Mail className="h-4 w-4" />
              Platform Invites
            </TabsTrigger>
          </TabsList>

          <TabsContent value="organizations">
            <OrganizationsTab />
          </TabsContent>

          <TabsContent value="site-invites">
            <SiteInvitesTab />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
